import React, { useEffect, useMemo } from 'react';
import { FieldControl, FormBuilder, Validators } from 'react-reactive-form';
import { markAllControlsDirtyAndTouched } from '../helpers/form.helper';
import { useAppContext } from '../contexts/AppContext';
import { Constants } from '../constants';
import { resetPassword } from '../services/login.service';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/ForgotPassword.css';
import '../styles/WebsiteStyle.css';
import { lmLogo } from '../assets/superAdminAssets';

const ForgotPassword = () => {
  const localHost = window.location.href.includes("localhost");
  const navigate = useNavigate();
  const { showLoader, hideLoader, showToaster, hideToaster } = useAppContext();
  const loginForm = useMemo(() => FormBuilder.group({
    EmailAddress: ["", [Validators.email, Validators.required]],
    WebURL: [localHost ? "https://superadmin.loanmantra.com" : window.location.origin],
  }), []);

  useEffect(() => {
    document.title = 'Loan Mantra - Forgot Password';
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    markAllControlsDirtyAndTouched(loginForm);
    showLoader();
    if (loginForm.status !== "INVALID") {
      resetPassword(loginForm.value).then(response => {
        if (response.status === 200) {
          hideLoader();
          let email = loginForm.value.EmailAddress;
          navigate("/success-screen", { state: { title: "Reset your password", subtitle: `Your request has been sent to ${email}` } });
          loginForm.reset();
        } else {
          hideLoader();
          showToaster(response.message, "error");
          setTimeout(() => hideToaster(), Constants.TOASTERHIDETIME);
        }
      }).catch(err => {
        hideLoader();
        showToaster(err.response.data.message, "error");
        setTimeout(() => hideToaster(), Constants.TOASTERHIDETIME);
      });
    } else {
      markAllControlsDirtyAndTouched(loginForm);
      hideLoader();
    }
  };


  return (
    <div className="website-wrap">
      <section className="forgot-body">
        <div className='pb-4 text-center'>
          <img src={lmLogo} alt="" />
        </div>
        <div className="container text">
          <div className="forgot-box">
            <h4>Reset your password</h4>
            <form onSubmit={handleSubmit}>
              <FieldControl
                strict={false}
                render={({ handler, touched, hasError }) => (
                  <div className={`form-group ${touched && (hasError('required') || hasError('invalidEmail')) ? 'error-field' : ''}`}>
                    <label htmlFor="email">
                      Email address
                      <span className="asterisk">*</span>
                    </label>
                    <input
                      {...handler()}
                      type="email"
                      className="form-control"
                      id="email"
                      aria-describedby="emailHelp"
                      placeholder="Enter email"
                    />
                    {touched && hasError('required') && (
                      <span className="error-message">
                        Email is required
                      </span>
                    )}
                    {touched && hasError('invalidEmail') && (
                      <span className="error-message">
                        Please enter a valid email address
                      </span>
                    )}
                  </div>
                )}
                control={loginForm.get('EmailAddress')}
              />
              <button type="submit" className="btn btn-login w-100">
                Reset Via Email
              </button>
            </form>

            <div className="text-center mt-4">
              <Link className="link-secondary" to="/">
                login
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgotPassword;


